/* eslint-disable no-console */
import {ISlidePreview} from '../incase-domain/proptypes/slidePreview';
import {httpPost} from './http.service';

export const uploadSlidePreview = (slidePreview: ISlidePreview): Promise<ISlidePreview> => {
    return httpPost(`editor/slides/savePreview`, slidePreview).catch((error) => {
        console.log(error);
    });
};

export const getSlidePreviews = (slideIds: string[]): Promise<ISlidePreview[]> => {
    return httpPost(`editor/slides/getPreview`, slideIds).catch((error) => {
        console.log(error);
    });
};
